import React, { ReactNode } from 'react'

interface ITextProps {
  children: ReactNode
}

export const Text = (props: ITextProps) => {
  return <p className="ly-notice__txt">{props.children}</p>
}
